const Create = () => {
    return (
        <>
            <p className="Help__Title">Crear grupo ahora</p>

            <img src='/img/support/help/instructor/groups/create/1.png' className='Help__Image' />
            <p>¿Qué hace este la opción <span className='Help__Text--Highlight'>Crear grupo ahora</span>?</p>
            <p>Al presionar este botón, Ztudia crea el grupo con el nombre que definiste y muestra el código único para que los Ztudiantes puedan unirse. Además, se habilitan varias opciones:</p>

            <img src='/img/support/help/instructor/groups/create/2.png' className='Help__Image'/>
            <p>Copiar código: para compartirlo fácilmente con los Ztudiantes.</p>

            <img src='/img/support/help/instructor/groups/create/3.png' className='Help__Image'/>
            <p>Agendar evaluación al grupo: para ir a las opciones para programar una evaluación para este grupo.</p>

            <img src='/img/support/help/instructor/groups/create/4.png' className='Help__Image'/>
            <p>Crear otro grupo: para regresar y crear un nuevo grupo.</p>

            <img src='/img/support/help/instructor/groups/create/5.png' className='Help__Image'/>
            <p>Ver grupo: para consultar si los Ztudiantes ya comenzaron a unirse.</p>
        </>
    )
}

export { Create };